import { render } from "./Category.vue?vue&type=template&id=8121982c"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"
script.render = render

export default script